import DeleteModal from '../../Modals/DeleteModal';
import AddZoneModal from './Modal/AddZoneModal';
import NotInformation from '../../../components/NotInformation';
import { permissionObj } from '../../../Helpers/permission';
import SearchSimple from '../../../components/SearchSimples/SearchSimple';
import HeadTittle from '../../../components/HeadTittle';
import { AddIcon, TrashOutlineIcon } from '../../../components/buttons/IconButtons';
import ButtonAction from '../../../components/buttons/ButtonAction';
import { ZoneApp } from "./Funtionality/ZoneApp";
import CustomExpandableTable from "../../../components/table/CustomExpandableTable";
import RenderExpandedRow from "./SubComponents/RenderExpandedRow"
import React from "react";


/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 *
 * @description
 * The `Zones` component is responsible for displaying and managing a list of zones.
 * It includes functionality for searching, selecting, adding, and deleting zones.
 *
 * @returns {JSX.Element} - The rendered Zones component.
 */

const Zones = () => {
    const {
        setModalShow, setDeleteShow, searchElement, setSearchElement, setSearchResults, setBodyForExport,
        setSearch, simpleSearch, setSimpleSearch, contractorId, supplierId,
        handleDeleteAll, searchResults, modalShow, deleteShow, deleteZone,
        handleCheckboxChange, option,pagination,page,
        rowsPerPage,childModalShow,setChildModalShow,
        modified,
        setModified,
        columns,
        renderOptionsMenu,
        handleRowExpand,
        selectedList,
        isFatherZone,
        t,
        DEV,
        permission
    } = ZoneApp();

    return (
        <>
            {/* Header section with action buttons */}
            <HeadTittle name={'first_access'}>
                {(DEV || permission?.includes(permissionObj?.WEB_ZONE_CREATE)) && (
                    <ButtonAction
                        id='btn_zn_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={() => setModalShow(true)}
                    />
                )}
                {(DEV || permission?.includes(permissionObj?.WEB_ZONE_DELETE)) && (
                    <ButtonAction
                        id='btn_zn_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => setDeleteShow(true)}
                    />
                )}
            </HeadTittle>

            {/* Search bar */}
            <SearchSimple
                id={"txt_zn_search_simple"}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setSearchResults={setSearchResults}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setBodyForExport={setBodyForExport}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={contractorId}
                supplierId={supplierId}
            />

                {searchResults?.content?.length > 0 ? (
                        <>
                            <CustomExpandableTable
                                columns={columns}
                                rows={searchResults.content}
                                renderExpandedRow={RenderExpandedRow}
                                renderOptionsMenu={(DEV || permission?.includes(permissionObj?.WEB_ZONE_READ)) && (renderOptionsMenu)}
                                onRowExpand={handleRowExpand}
                                selectedList={selectedList}
                                handleCheckboxChange={handleCheckboxChange}
                                handleDeleteAll={handleDeleteAll}
                                rowsPerPage={rowsPerPage}
                            />
                            {pagination()}
                        </>
                ) : (
                    <NotInformation
                        card={true}
                        text={t('no_zone_text')}
                        showButton={((DEV || permission?.includes(permissionObj?.WEB_ZONE_CREATE)) && searchResults?.content?.length === 0)}
                        buttonId={'btn_zn_link_create'}
                        buttonTrans={'created_zone'}
                        buttonOnclick={() => setModalShow(true)}
                    />
                )}

            {/* Modal for adding a new zone */}
            { modalShow &&
                <AddZoneModal
                    title={t('create')}
                    sub_title={t('zone')}
                    check='false'
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    modified={modified}
                    setModified={setModified}
                />
            }

            { childModalShow &&
                <AddZoneModal
                    title={t('create_new_zone_first_access')}
                    check='true'
                    show={childModalShow}
                    sub_title={t('sub_zone')}
                    onHide={() => setChildModalShow(false)}
                    isFatherZone={isFatherZone}
                    modified={modified}
                    setModified={setModified}

                />
            }

            {/* Modal for deleting selected zones */}
            { deleteShow &&
                <DeleteModal
                    show={deleteShow}
                    onHide={() => {setDeleteShow(false)}}
                    onClickFn={() => deleteZone(selectedList)}
                    data={selectedList}
                    title_modal={'delete_first_access_zone'}
                    description={'are_you_sure_you_want_to_delete'}
                    element_modal={'zone'}
                />
            }

        </>
    );
};

export default Zones;
